import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentTeams } from '../../../classroom360/student-teams/student-teams.model';
import { System } from '../../../shared-components/System';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {

  constructor(private http: HttpClient) { }

  getTeamsByStudentId(studentId: number, yearId: number, schoolId: number): Observable<StudentTeams[]> {
    const queryString = '?studentId=' + studentId
      + '&yearId=' + yearId
      + '&schoolId=' + schoolId;
    return this.http.get<StudentTeams[]>(System.apiURL.Admin + 'GetTeamsByStudentId' + queryString);
  }

  deleteTeamByStudentId(studentId: number, teamId: number): Observable<boolean> {
    const queryString = '?studentId=' + studentId + '&teamId=' + teamId;
    return this.http.get<boolean>(System.apiURL.Admin + 'DeleteTeamByStudentId' + queryString);
  }

  getTeamList(schoolId: number, yearId: number): Observable<StudentTeams[]> {
    const queryString = '?siteId=' + schoolId
      + '&yearId=' + yearId;
    return this.http.get<StudentTeams[]>(System.apiURL.Admin + 'GetTeamList' + queryString);
  }

  saveStudentToTeam(studentId: number, data: StudentTeams): Observable<void> {
    const queryString = '?studentId=' + studentId;
    return this.http.post<void>(System.apiURL.Admin + `SaveStudentToTeam` + queryString, data);
}
}
